<article
  class="page-container"
  [innerHTML]="document?.content">
</article>